//import { Component } from '@angular/core';
//import { RouterOutlet } from '@angular/router';
//import { ConfirmDialogModule } from 'primeng/confirmdialog';
//import { ToastModule } from 'primeng/toast';

//@Component({
//  selector: 'app-root',
//  standalone: true,
////  imports: [RouterOutlet,
// ToastModule,
// ConfirmDialogModule
//  ],
//template: '<router-outlet />'
//})
//export class AppComponent {}

import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

// PrimeNG
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { PrimengLocaleService } from './services/primeng-locale.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, ToastModule, ConfirmDialogModule],
  providers: [MessageService, ConfirmationService],
  template: `
    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>
    <router-outlet></router-outlet>
  `,
})
export class AppComponent {
  constructor(private locale: PrimengLocaleService) {
    this.locale.init();
  }
}
